import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Toaster } from "@/components/ui/sonner";
import FeedbackButton from "@/components/FeedbackButton";
import ScrollManager from "@/components/ScrollManager";

const MainLayout = () => {
  const location = useLocation();

  // Only show footer on the public landing page
  const showFooter = location.pathname === '/';

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollManager />
      <Navbar />
      {/* ScrollManager moves focus here on a new page; the region itself isn't a control, so no ring. */}
      <main className="flex-1 pt-20 focus:outline-none">
        <Outlet />
      </main>
      <Toaster />
      {showFooter && <Footer />}
      <FeedbackButton />
    </div>
  );
};

export default MainLayout;
